module.exports = __webpack_public_path__ + "static/media/1001000TL.878f3f19.jpg";